import { ChevronLeft, ChevronRight } from 'lucide-react';

interface Props {
  years: number[];
  selectedYear: number;
  onChange: (year: number) => void;
  formatYear?: (year: number) => string;
}

export default function YearNavigator({ years, selectedYear, onChange, formatYear }: Props) {
  const idx = years.indexOf(selectedYear);
  const hasPrev = idx > 0;
  const hasNext = idx < years.length - 1;

  return (
    <div className="flex items-center gap-0.5 border border-neutral-200 rounded-lg bg-white overflow-hidden">
      <button
        onClick={() => hasPrev && onChange(years[idx - 1])}
        disabled={!hasPrev}
        className="px-2 py-1.5 hover:bg-neutral-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors border-r border-neutral-200"
      >
        <ChevronLeft className="w-3.5 h-3.5 text-neutral-600" />
      </button>
      <select
        value={selectedYear}
        onChange={(e) => onChange(Number(e.target.value))}
        className="text-xs font-medium text-neutral-700 bg-transparent px-2 py-1.5 cursor-pointer hover:bg-neutral-50 transition-colors appearance-none text-center min-w-[56px]"
      >
        {years.map((y) => (
          <option key={y} value={y}>
            {formatYear ? formatYear(y) : `FY${y}`}
          </option>
        ))}
      </select>
      <button
        onClick={() => hasNext && onChange(years[idx + 1])}
        disabled={!hasNext}
        className="px-2 py-1.5 hover:bg-neutral-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors border-l border-neutral-200"
      >
        <ChevronRight className="w-3.5 h-3.5 text-neutral-600" />
      </button>
    </div>
  );
}
